<div *ngIf="!loading.status">
    <div class="project-totals" *ngIf="projectTotals">
        <table class="table" aria-label="Report Totals legend">
            <tr style="display:none;">
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
            </tr>
            <tr>
                <td>Total projects:&nbsp;{{ projectTotals.totalProjects }}</td>
                <td>TIP:&nbsp;{{ projectTotals.tipProjects }}</td>
                <td>Draft TIP:&nbsp;{{ projectTotals.draftProjects }}</td>
                <td>Total bridges:&nbsp;{{ projectTotals.totalBridges }}</td>
                <td>Poor condition bridges:&nbsp;{{ projectTotals.sdBridges }}</td>
            </tr>
        </table>
        <hr>
    </div>
    <ul class="list-unstyled">
        <li *ngFor="let report of reportsToShow" class="list-item">
            <div class="inline-block">
                {{ report.title }}&nbsp;
                <br />
                <span class="report-total" *ngIf="report.reportType === 'projects'">({{ projectTotals.totalProjects }} projects available)</span>
                <span class="report-total" *ngIf="report.reportType === 'tip'">({{ projectTotals.tipProjects }} TIP projects available)</span>
                <span class="report-total" *ngIf="report.reportType === 'draft'">({{ projectTotals.draftProjects }} Draft TIP projects available)</span>
                <span class="report-total" *ngIf="report.reportType === 'sd'">({{ projectTotals.sdBridges }} Poor condition bridges available)</span>
                <span class="report-total" *ngIf="report.reportType === 'bridges'">({{ projectTotals.totalBridges }} bridges available)</span>
            </div>
            <button class="btn right button" [disabled]="report.disabled" (click)="generateReport(report)">Generate</button>
            <button class="btn btn-clear right" [disabled]="report.disabled" *ngIf="report.csvPrint" (click)="generateReport(report, true)">Generate CSV</button>
        </li>
    </ul>
    <div class="alert alert-yellow is-active" *ngIf="reportsToShow.length === 0">
        There are no reports available at this time. Select a region in the AOI or try adding a Bridge or Project layer to the
        map first.
    </div>
</div>
<div *ngIf="loading.status">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">{{ loading.text }}</div>
    </div>
</div>
